<template>
  <div class="full-container">
    <div
        style="width: 100%;float: left;height: 50px;line-height: 50px;font-size: 0.9rem; text-align: left;opacity: 0.9;">
      农业资料库>药肥登记证号
    </div>
    <div style="width:100%;height:auto;float:left;border-radius: 15px;background-color: white;padding-bottom:40px;">

      <div style="width:100%;float:left;margin-top: 10px;">
        <!-- 查询按钮区 -->
        <div style="width: 100%;height: 60px;float: left;line-height: 60px;padding-left: 15px">
          <!-- 左边查询区 -->
          <div style="width: auto;float: left;margin-right: 20px">
            <label style="float: left;font-size: 0.9rem;opacity: 0.9;">登记证号：</label>
            <el-input v-model="selectForm.no" clearable placeholder="模糊查询" prefix-icon="el-icon-search"
                      size="mini" style="width: 200px;float: left;"></el-input>
          </div>
          <div style="width: auto;float: left;margin-right: 20px">
            <label style="float: left;font-size: 0.9rem;opacity: 0.9;">企业名称：</label>
            <el-input v-model="selectForm.companyName" clearable placeholder="模糊查询" prefix-icon="el-icon-search"
                      size="mini" style="width: 200px;float: left;"></el-input>
          </div>
          <div style="width: auto;float: left;margin-right: 20px">
            <label style="float: left;font-size: 0.9rem;opacity: 0.9;">药肥名称：</label>
            <el-input v-model="selectForm.name" clearable placeholder="模糊查询" prefix-icon="el-icon-search"
                      size="mini" style="width: 200px;float: left;"></el-input>
          </div>
          <div style="width: auto;float: left;margin-right: 20px">
            <el-button size="mini" style="background-color: #25AD7F;border:none;" type="primary"
                       @click="pageAllQualification(true)">搜索
            </el-button>
            <el-button size="mini" style="background-color: #25AD7F1A;border:1px solid #25AD7F;color:#25AD7F"
                       type="primary" @click="selectReset()">重置
            </el-button>
          </div>

          <!-- 右边按钮 -->
          <div style="width: auto;float: right;margin-right: 20px">


            <el-button size="mini" style="background-color: #25AD7F1A;border:1px solid #25AD7F;color:#25AD7F"
                       type="primary" @click="exportTable">
              <a-icon type="plus-circle"/>
              批量导出
            </el-button>


          </div>


        </div>

        <!-- 表单内容 -->
        <div style="width:100%;float:left;padding: 15px;">
          <el-table v-loading="tableLoading" :data="tableData" align="center" height="600" size="mini"
                    style="color: #555;" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column align="center" label="登记证号" min-width="30%" prop="no"></el-table-column>
            <el-table-column align="center" label="登记证持有人" min-width="30%" prop="companyName"></el-table-column>
            <el-table-column align="center" label="药肥名称" min-width="20%" prop="name"></el-table-column>
            <el-table-column align="center" label="剂型" min-width="20%" prop="dosage"></el-table-column>
            <el-table-column align="center" label="毒性" min-width="20%" prop="toxicity"></el-table-column>
            <el-table-column align="center" label="有效成分及其含量" min-width="20%"
                             prop="proportioning"></el-table-column>
            <el-table-column align="center" label="药肥类别" min-width="20%" prop="type"></el-table-column>
            <el-table-column align="center" label="作物/场所" min-width="20%" prop="crop"></el-table-column>
            <el-table-column align="center" label="防治对象" min-width="20%" prop="control"></el-table-column>
            <el-table-column align="center" label="产品质量标准号" min-width="20%" prop="standard"></el-table-column>
            <el-table-column align="center" label="操作" min-width="20%">
              <template slot-scope="scope">
                <span style="font-size:0.9rem;color:#25AD7F;cursor: pointer;" @click="detailShow(scope.row)">详情</span>
              </template>
            </el-table-column>
          </el-table>
          <div style="width: 100%;float: right;margin-top: 10px;text-align: right;">
            <el-pagination
                :current-page="selectForm.pageIndex"
                :page-size="selectForm.pageSize"
                :total="selectForm.total"
                layout="total,prev, pager, next"
                @current-change="handleCurrentChange">
            </el-pagination>
          </div>
        </div>
      </div>
    </div>


    <!-- 详情 -->
    <el-dialog :before-close="detailCancel" :visible.sync="detailDialog" title="药肥登记证号详情" width="40%">
      <div style="width: 100%;float: left">
        <div
            v-if="detailInfo"
            style="width: 100%;float: left;border-bottom: 1px solid #80808054;padding-bottom: 15px;margin-bottom: 20px;">
          <el-descriptions :column=2 :title="detailInfo.name?detailInfo.name:''">
            <el-descriptions-item label="登记证号">{{ detailInfo.no ? detailInfo.no : "" }}
            </el-descriptions-item>
            <el-descriptions-item label="登记证持有人">{{ detailInfo.companyName ? detailInfo.companyName : "" }}
            </el-descriptions-item>
            <el-descriptions-item label="药肥名称">{{ detailInfo.name ? detailInfo.name : "" }}
            </el-descriptions-item>
            <el-descriptions-item label="剂型">{{ detailInfo.dosage ? detailInfo.dosage : "" }}
            </el-descriptions-item>
            <el-descriptions-item label="毒性">{{ detailInfo.toxicity ? detailInfo.toxicity : "" }}
            </el-descriptions-item>
            <el-descriptions-item label="有效成分及其含量">{{
                detailInfo.proportioning ? detailInfo.proportioning : ""
              }}
            </el-descriptions-item>
            <el-descriptions-item label="药肥类别">{{ detailInfo.type ? detailInfo.type : "" }}
            </el-descriptions-item>
            <el-descriptions-item label="作物/场所">{{ detailInfo.crop ? detailInfo.crop : "" }}
            </el-descriptions-item>
            <el-descriptions-item label="防治对象">{{ detailInfo.control ? detailInfo.control : "" }}
            </el-descriptions-item>
            <el-descriptions-item label="使用方法">{{ detailInfo.useMethod ? detailInfo.useMethod : "" }}
            </el-descriptions-item>
            <el-descriptions-item label="产品质量标准号">{{ detailInfo.standard ? detailInfo.standard : "" }}
            </el-descriptions-item>
          </el-descriptions>
        </div>

      </div>
      <div class="dialog-footer">
        <el-button class="dialog-footer-cancel" @click="detailCancel">关闭</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>


import * as XLSX from "xlsx";

import {pageAllQualificationApi} from "@/router/api/tool/qualification-api";

export default {
  name: "QualificationIndex",
  data() {
    return {

      // 查询
      tableData: [],
      selectForm: {
        no: null,
        companyName: null,
        name: null,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      },
      selectTableRow: [],
      tableLoading: false,


      //  详情
      detailDialog: false,
      detailInfo: null,


    };
  },

  mounted() {

    this.load();


  },

  methods: {

    load() {
      this.pageAllQualification();
    },


    // 查询 begin
    selectReset() {
      this.selectForm = {
        no: null,
        companyName: null,
        name: null,
        pageIndex: 1,
        pageSize: 10,
        total: 0
      };
      this.pageAllQualification(true);
    },

    handleCurrentChange(e) {
      this.selectForm.pageIndex = e;
      this.pageAllQualification(true);
    },

    handleSelectionChange(val) {
      this.selectTableRow = val;
    },

    pageAllQualification(showMessage) {
      this.tableLoading = true;
      pageAllQualificationApi(this.selectForm, res => {
        if (res.status == "200") {
          if (res.data && res.data.status && res.data.msg) {
            if ("1" == res.data.status) {
              if (showMessage) {
                this.showMessage(res.data.msg, "success");
              }
              this.tableData = res.data.resultSetData.list;
              this.selectForm.pageIndex = res.data.resultSetData.pageNum;
              this.selectForm.pageSize = res.data.resultSetData.pageSize;
              this.selectForm.total = res.data.resultSetData.total;
            } else {
              this.showMessage(res.data.msg, "error");
            }
          } else {
            this.showMessage("未知请求出错", "error");
          }
        } else {
          this.showMessage("未知请求出错！", "error");
        }
      }, res => {
        this.tableLoading = false;
      });
    },

    exportTable() {
      if (!this.selectTableRow || this.selectTableRow.length == 0) {
        this.showMessage("请勾选需要导出的数据", "warning");
        return false;
      }


      const data = [
        [
          "登记证号",
          "登记证持有人",
          "药肥名称",
          "剂型",
          "毒性",
          "有效成分及其含量",
          "药肥类别",
          "作物/场所",
          "防治对象",
          "产品质量标准号"
        ]
      ]
      for (let i = 0; i < this.selectTableRow.length; i++) {
        let row = this.selectTableRow[i];
        if (row) {
          let cell0 = row.no ? row.no : "";
          let cell1 = row.companyName ? row.companyName : "";
          let cell2 = row.name ? row.name : "";
          let cell3 = row.dosage ? row.dosage : "";
          let cell4 = row.toxicity ? row.toxicity : "";
          let cell5 = row.proportioning ? row.proportioning : "";
          let cell6 = row.type ? row.type : "";
          let cell7 = row.crop ? row.crop : "";
          let cell8 = row.control ? row.control : "";
          let cell9 = row.standard ? row.standard : "";
          data.push([cell0, cell1, cell2, cell3, cell4, cell5, cell6, cell7, cell8, cell9]);
        }
      }
      // 将数据转换为工作表
      const worksheet = XLSX.utils.aoa_to_sheet(data);

      // 创建工作簿并添加工作表
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // 生成Excel文件
      const excelBuffer = XLSX.write(workbook, {bookType: "xlsx", type: "array"});

      // 使用blob和FileReader创建一个Blob URL
      const dataBlob = new Blob([excelBuffer], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"});
      const blobUrl = window.URL.createObjectURL(dataBlob);

      // 使用saveAs下载文件
      saveAs(dataBlob, "药肥登记证号-" + new Date().toLocaleString() + ".xlsx");

      // 清理
      window.URL.revokeObjectURL(blobUrl);
    },

    // 查询 end


    // 详情 begin
    detailShow(data) {
      this.detailInfo = data;
      this.detailDialog = true;
    },

    detailCancel() {
      this.detailDialog = false;
      this.detailInfo = null;
    },
    // 详情 end


    // 工具
    parseDate(date) {
      if (date) {
        return new Date(date).toLocaleString();
      }
      return "";
    }
  }


}
;

</script>


<style scoped>

/deep/ .el-card__body, .el-main {
  float: left;
  width: 100%;
}

/*  通用 */
.dialog-footer {
  width: 100%;
  float: left;
  text-align: left;
}

.dialog-footer-submit {
  background-color: #25AD7F;
  color: white;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-submit:hover {
  background-color: #25AD7F;
  color: white;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-cancel {
  background-color: white;
  border: 1px solid #8080805c;
  color: #8080805c;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

.dialog-footer-cancel:hover {
  background-color: white;
  border: 1px solid #8080805c;
  color: #8080805c;
  width: 130px;
  border-radius: 50px;
  letter-spacing: 3px;
  text-align: center;
  font-weight: 100;
}

/* 树形菜单 */

/deep/ .el-tree-node__content {
  height: 35px;
  line-height: 35px;
}

/* 表格 */

/deep/ .el-table th.el-table__cell {
  background-color: #F8F8F8;
}

/deep/ .el-table th.el-table__cell > .cell {
  color: #554 !important;
  font-weight: 600;
  font-size: 1.05rem;
}


/* 模态框 */

/deep/ .el-dialog__title {
  font-weight: 600;
}

/deep/ .el-dialog__header {
  text-align: left;
  border-bottom: 1px solid darkgray;
}

/deep/ .el-dialog__body {
  width: 100%;
  float: left;
  background-color: white;
}

/deep/ .el-upload-dragger {
  height: auto;
}

/deep/ .el-form-item__content {
  text-align: left;
}


/* 纯数字 */
/deep/ .numberInput input::-webkit-outer-spin-button,
/deep/ .numberInput input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}

/deep/ .numberInput input[type="number"] {
  -moz-appearance: textfield;
}

</style>
